<template>
    <v-form @submit.prevent="addEditProjectTask" ref="form">
        <v-card dense style="border-radius:4px;">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold ">{{mode}} Project Task</span>
                <v-spacer></v-spacer>
                <help-link appId="projects" pageId="creating-task" color="black"></help-link>
                <v-btn icon @click.native="closeDialog" :disabled="disabled">
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout row wrap class="form-container">   
                    <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                        {{errorMessage}}
                    </v-alert>   
                    <v-flex xs12 sm12>
                        <v-text-field 
                            label="Task Code" 
                            v-model="taskCode" 
                            :rules="[rules.required, rules.max_50]" 
                            :disabled="disabled"
                            hint="Max 50 characters"
                            append-icon="more_horiz"
                            @click:append="browseTaskCode"
                            @keyup="error=false" 
                            ></v-text-field>
                        <v-text-field label="Task Name" 
                            v-model="taskName" 
                            :rules="[rules.required, rules.max_100]" 
                            :disabled="disabled"
                            append-icon="more_horiz"
                            @click:append="browseName"
                            max="100"
                            @keyup="error=false" rows="1"></v-text-field>
                        <v-textarea label="Task Description" 
                            v-model="taskDescription" 
                            :rules="[rules.required, rules.max_1000]" 
                            :disabled="disabled"
                            max="1000"
                            @keyup="error=false" rows="1"></v-textarea>
                        <v-switch
                            v-model="billable"
                            label="Billable"
                            color="primary"
                            hide-details
                            :disabled="disabled"
                        ></v-switch>
                    </v-flex>
             </v-layout>
            </v-card-text>  
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :loading="loading" style="color:white">Save</v-btn>
                <v-btn v-if="mode!='Edit'" @click="clearForm" :disabled="disabled" >clear</v-btn>
            </v-card-actions>
        </v-card>
        <v-dialog v-model="dialogCopy" width="650">   
            <copy-existing ref="copyExistingRef" @send="copyName" :dialogCopy.sync="dialogCopy"></copy-existing>
        </v-dialog>
    </v-form>
</template>
<script>
import projectsApi from '@/api/projects'
export default {
    name: 'AddEditTask',
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'copy-existing': () => import('@/components/Projects/CopyExistingName')
    }, 
    data () {
      return {
            error: false,
            errorMessage: '', 
            loading: false,
            disabled: false,  
            dialogCopy: false,   
            rules: {
                required: value => !!value || 'Required.',
                max_50: value => value.length <= 50 || "Max 50 characters",
                max_100: value => value.length <= 100 || "Max 100 characters",
                max_1000: value => value.length <= 1000 || "Max 1000 characters",
            },
            mode: '',
            projectTaskKey: '',
            projectTaskId: '0',
            projectId: '0',
            taskCode: '',
            taskName: '',
            taskDescription: '',       
            billable: false,
            copy_list: null
        }
    },
    methods: {
        browseTaskCode() {
            const data = {
                type: 'task_code'
            }
            this.$refs.copyExistingRef.setData(data)
            this.dialogCopy = true
        },
        browseName() {
            const data = {
                type: 'task_name'
            }
            this.$refs.copyExistingRef.setData(data)
            this.dialogCopy = true
        },
        copyName(data) {
            switch(data.type) {
                case 'task_code':
                    this.taskCode = data.name
                    break;
                case 'task_name':
                    this.taskName = data.name
                    break;
            }
        },
        closeDialog() {
            this.$emit('update:dialogProjectTask', false)
            this.clearForm()
        },
        setProjectTaskAdd(projectId) {
            this.clearForm()  
            this.mode = 'Add'
            this.projectId = projectId
        },
        setData(data) {
            this.mode = 'Edit'
            this.projectTaskKey = data.projectTaskKey
            this.projectTaskId = data.projectTaskId
            this.projectId = data.projectId
            this.taskCode = data.taskCode
            this.taskName = data.taskName
            this.taskDescription = data.taskDescription
            this.billable = data.billable
        },
        async addEditProjectTask() {         
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true
                    this.disabled = true
                    
                    var data = {
                        projectTaskId: this.projectTaskId,
                        projectId: this.projectId,
                        taskCode: this.taskCode,
                        taskName: this.taskName,
                        taskDescription: this.taskDescription,
                        billable: this.billable
                    }

                    var responsse = null
                    if (this.mode == 'Add')
                        responsse = await projectsApi.addProjectTask(data)
                    else
                        responsse = await projectsApi.updateProjectTask(data)

                    if (responsse && responsse.status == 200) {
                        this.loading = false
                        this.disabled = false                    
                        this.closeDialog()
                        this.$emit('send', '')
                    }
                }catch(error){
                    this.errorMessage = error
                    this.error = true
                }        
            }
        },        
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
        }
    },
    computed: {},
    created() {}
}
</script>
<style scoped>
.form-container {
    padding:0px 20px 0px 20px;
}
</style>